import api from './api';

/**
 * Chiamate del magazzino.
 *
 * Le regole stanno nel database: qui non si duplicano controlli,
 * si presentano i messaggi che arrivano.
 *
 * Tutte queste rotte sono riservate ad admin e segreteria, comprese le
 * letture: chi ha un altro ruolo riceve 403 e non deve vedere le
 * schermate che le usano.
 */
export const magazzinoAPI = {
    // --- prodotti
    prodotti: (params) => api.get('/magazzino/prodotti', { params }),
    creaProdotto: (dati) => api.post('/magazzino/prodotti', dati),
    aggiornaProdotto: (id, dati) => api.put(`/magazzino/prodotti/${id}`, dati),
    /* La distinta vista dal prodotto: quali prestazioni lo consumano. */
    prestazioniProdotto: (id) => api.get(`/magazzino/prodotti/${id}/prestazioni`),
    impostaPrestazioniProdotto: (id, prestazioni) =>
        api.put(`/magazzino/prodotti/${id}/prestazioni`, { prestazioni }),
    disattivaProdotto: (id) => api.delete(`/magazzino/prodotti/${id}`),

    // --- distinta: quali prodotti consuma una prestazione
    distinte: () => api.get('/magazzino/distinte'),
    distinta: (prestazioneId) => api.get(`/magazzino/distinta/${prestazioneId}`),
    // Le prestazioni che non dicono che cosa consumano.
    senzaDistinta: () => api.get('/magazzino/senza-distinta'),
    impostaDistinta: (prestazioneId, righe) =>
        api.put(`/magazzino/distinta/${prestazioneId}`, { righe }),

    // --- consultazione
    giacenze: (params) => api.get('/magazzino/giacenze', { params }),
    riepilogo: (giorni) => api.get('/magazzino/riepilogo', { params: { giorni } }),
    scadenze: (giorni = 90) => api.get('/magazzino/scadenze', { params: { giorni } }),
    lotti: (params) => api.get('/magazzino/lotti', { params }),
    costi: () => api.get('/magazzino/costi'),
    movimenti: (params) => api.get('/magazzino/movimenti', { params }),
    daScaricare: (visitaId) => api.get(`/magazzino/da-scaricare/${visitaId}`),
    codaScarico: (giorni = 30) => api.get('/magazzino/coda-scarico', { params: { giorni } }),
    scaricoMultiplo: (righe) => api.post('/magazzino/scarico-multiplo', { righe }),
    tracciabilita: (lottoId) => api.get(`/magazzino/tracciabilita/${lottoId}`),
    perPaziente: (pazienteId) => api.get(`/magazzino/paziente/${pazienteId}`),

    // --- movimentazione
    carico: (dati) => api.post('/magazzino/carico', dati),
    scarico: (dati) => api.post('/magazzino/scarico', dati),
    rettifica: (dati) => api.post('/magazzino/rettifica', dati),
    costoLotto: (id, costo_unitario, motivo) => api.put(`/magazzino/lotti/${id}/costo`, { costo_unitario, motivo }),

    // --- carico da fattura elettronica
    importaXml: (contenuto, nomeFile) =>
        api.post('/magazzino/importa-xml', { contenuto, nome_file: nomeFile }),
    /* PDF o scansione: il server mette in coda e risponde 202 con
       l'id della lettura; poi si chiede a che punto e'. */
    importaPdf: (file, tipo = 'fattura') => {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('tipo', tipo);
        return api.post('/magazzino/importa-pdf', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    },
    statoImportaPdf: (id) => api.get(`/magazzino/importa-pdf/${id}`),
    /* Le letture in attesa di conferma: fotografate dal telefono o
       caricate da qui, non ancora caricate in magazzino. */
    lettureInAttesa: () => api.get('/magazzino/importa-pdf'),
    confermaCarico: (dati) => api.post('/magazzino/conferma-carico', dati),
    documentiCarico: () => api.get('/magazzino/documenti-carico'),
    abbinamenti: (q) => api.get('/magazzino/abbinamenti', { params: { q } }),
    eliminaAbbinamento: (id) => api.delete(`/magazzino/abbinamenti/${id}`),
};

export default magazzinoAPI;
